module.exports = __webpack_public_path__ + "media/images/vp/tutorialpopup.1-1e74764a2ed2eeca2195c96396237fcc.svg";